import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
} from 'react'
import { IModalContent } from '../interfaces/modal'
import Modal from '../components/modal'

type IProps = {
  children: ReactNode;
}

type ModalContextProps = {
  isVisible: boolean;
  toggleVisibility: (value?:boolean) => void;
  content: IModalContent;
  updateContent: (value: IModalContent) => void;
  updateProps: (value: any) => void;
}

const ModalContext = createContext({} as ModalContextProps)

const initialModalContent = {
  title: '',
  width: '474px',
}

const ModalProvider = ({ children }: IProps): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false)
  const [content, setContent] = useState<IModalContent>(initialModalContent)
  const [props, setProps] = useState<any>({})

  const toggleVisibility = (value?:boolean) => {
    if (value) {
      setIsVisible(value)
      return
    }

    setIsVisible((state) => !state)
  }

  const updateProps = (value: any) => {
    setProps(value)
  }

  const updateContent = (value: IModalContent) => {
    setContent(value)
  }

  return (
    <ModalContext.Provider
      value={{
        isVisible,
        toggleVisibility,
        content,
        updateContent,
        updateProps,
      }}
    >
      {children}
      <Modal
        content={content}
        isVisible={isVisible}
        toggleVisibility={toggleVisibility}
        {...props}
      />
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const context = useContext(ModalContext)

  if (!context) {
    throw new Error('useModal must be used within a provider ModalProvider')
  }

  return context
}

export default ModalProvider
